export default __webpack_public_path__ + "ocr-insurance83dcca.jpeg";